export default {
  generalEnums: [],
  enums: [],
  enumsCount: 0
}
